import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { QueryTable } from "@/components/query-table/QueryTable";
import { useContractorsPlannedHoursWizardColumnOverrides } from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardColumnOverrides";
import { useContractorsPlannedHoursWizardQuery } from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardQuery";
import { displayContractorsPlannedHoursWizardAllocation } from "@/schemas/contractorsPlannedHoursWizard";
import { DataTableFeatures } from "@/types/dataTableSettings";
import { DisplayContractorsPlannedHoursWizardAllocation } from "@/types/contractorsPlannedHoursWizard";
import { useMemo } from "react";

export function ContractorsPlannedHoursWizardAllocationsList({
  columnOverrides,
}: {
  columnOverrides: ReturnType<
    typeof useContractorsPlannedHoursWizardColumnOverrides
  >;
}) {
  const tableName = "contractorsPlannedHoursWizardAllocations";
  const { query: infiniteQuery, options } =
    useContractorsPlannedHoursWizardQuery(tableName);
  const queryValue = useMemo(() => ({ query: infiniteQuery }), [infiniteQuery]);
  const allocationsFeatures = useMemo(
    (): DataTableFeatures => ({
      enableRowSelection: true,
      enableSelectAll: true,
      enableSorting: true,
      enableColumnPinning: true,
      enableColumnOrder: true,
      initialColumnVisibility: { id: false },
      enableOnlySelectedFilter: true,
      enableFilters: true,
    }),
    [],
  );
  return (
    <QueryTable<DisplayContractorsPlannedHoursWizardAllocation>
      schema={displayContractorsPlannedHoursWizardAllocation}
      name={tableName}
      translationKey="contractorsPlannedHoursWizard"
      query={infiniteQuery}
      options={options}
      tableFeatures={allocationsFeatures}
      columnOverrides={columnOverrides}
    >
      <DataTableQueryContextProvider value={queryValue}>
        <div className="flex min-h-0 flex-1 flex-col gap-1">
          <QueryTable.Menubar className="mb-0 min-w-0 w-full shrink-0">
            <QueryTable.Menubar.Columns />
            <QueryTable.Menubar.Settings />
            <QueryTable.Menubar.OnlySelected />
          </QueryTable.Menubar>
          <QueryTable.Content className="min-h-0 flex-1 flex-col">
            <div className="flex min-h-14 w-full shrink-0 items-center">
              <QueryTable.Status>
                <QueryTable.SelectedRowsStatus />
              </QueryTable.Status>
            </div>
          </QueryTable.Content>
        </div>
      </DataTableQueryContextProvider>
    </QueryTable>
  );
}
